<template>
</template>

<script>
import {CampaignBannerType} from "../../../../view-model/enum/CampaignBannerType";

/**
 * 筐体紹介ページ共通テンプレートのトップに表示するバナーを設定する
 * 表示対象のバナーをCampaignBannerTypeに追加し、targetBannerTypeで返却する処理を追加
 */
export default {
    name: "MachineTopCampaignBanner",

    props: {
        /** 対象の筐体ID */
        machineId: {
            type: Number,
            required: true,
        },

        /** タイムトリップした日付 */
        timeTripDate: {
            type: Object,
            required: true
        }
    },

    computed: {
        targetBannerType() {
            return null
        },
        bannerType() {
            return CampaignBannerType
        }
    }
}
</script>
